import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Context } from '../App'
import { API } from '../conf'
import {Backdrop, Box, Button, CircularProgress, Dialog, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, Stack, TableCell, TextField, Typography } from '@mui/material'
import Header from '../Components/layout/Header'
import { Check, Close, InfoOutlined, InsertDriveFileOutlined, PrintOutlined, Replay, Search, WarningAmber } from '@mui/icons-material'
import SorTableCheckable from '../Components/ui/sortable-checkable'
import pdfMake from "pdfmake/build/pdfmake";
import {bord_versement} from "../asset/pdfmaker";
import moment from 'moment';
import pdfFonts from "pdfmake/build/vfs_fonts";
import VersHistory from '../Components/sections/vers-history'
import VersWarning from './versement-warning'
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

export default function VersementsManager(props) {
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [vers, setVers] = useState([])
    const [selectedMCol, setSelectMCol] = useState(["Montant"])
    const [montant, setMontant] = useState('')
    const [search_input, setSearch] = useState('')
    const [selectItems, setItems] = useState([])
    const [selected, setSelect] = useState()
    const [pdf, setPdf] = useState()
    const [action, setAction] = useState()
    const [open, setOpen] = useState(false)

    const filteredVers = useMemo(()=>action==='cash many'&&open ? vers.filter(v=>selectItems.includes(v._id)) : [], [vers, selectItems, open, action])
    const selectedEspeces = useMemo(()=>selected?[...selected.fedRepartition.especes, ...selected.fedRepartition.retrait].filter(es=>es.montant>0&&es.count>0):[],[selected])

    const editCol = {header: "", sortable: false, row: (row, index)=><TableCell key={index} align='right' sx={{minWidth:'180px'}} >
        {row.is_error&&<IconButton aria-label='annuler le signalement' onClick={()=>{setSelect(row); manage_dialog(true, 'cancelWarning')}}><Replay fontSize='small'/></IconButton>}
        <IconButton aria-label="signaler" color={row.is_error ? 'error' : 'default'} onClick={()=>{setSelect(row); manage_dialog(true, 'warning')}}><WarningAmber fontSize="small"/></IconButton>
        <IconButton aria-label="Edit bordereau de versement" onClick={()=>get_bdr_versement(row)}><InsertDriveFileOutlined fontSize="small"/></IconButton>
        <IconButton aria-label="imprimer" onClick={()=>print_bdr(row)}><PrintOutlined fontSize="small"/></IconButton>
        <IconButton aria-label="informations complémentaires" onClick={()=>{setSelect(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
        {!row.is_error&&<IconButton aria-label="encaisser" onClick={()=>{setSelect(row); manage_dialog(true, 'cash')}}><Check fontSize="small"/></IconButton>}
    </TableCell>}
    const montant_columns = [
        {header: "Espèces", search:(row)=>[...row.fedRepartition.especes, ...row.fedRepartition.retrait].reduce((tt,es)=>tt+es.montant.toFixed(2)+' ','')},
        {header: "Chèques", search:(row)=>row.fedRepartition.cheques?.reduce((tt,cq)=>tt+cq.montant.toFixed(2)+' ','')},
        {header: "Montant", search:(row)=> [...row.fedRepartition.especes, ...row.fedRepartition.retrait].reduce((tt,es)=>tt+es.montant*es.count,0).toFixed(2)},
    ]
    const table = [
        {header: "N°", sortable: true, sortBy:(el)=>el.bordereau_num, row: (row, index)=><TableCell key={index} align="center" >{row.bordereau_num}</TableCell>},
        {header: "Date", sortable: true, sortBy:(el)=>new Date(el.date_jour).getTime(), row: (row, index)=><TableCell key={index} align="center" >{moment.utc(row.date_jour).format('DD/MM/YYYY')}</TableCell>},
        {header: "Date dons", sortable: true, sortBy:(el)=>new Date(el.dateDons).getTime(), row: (row, index)=><TableCell key={index} align="center" >{moment.utc(row.dateDons).format('DD/MM/yyyy')}</TableCell>},
        {header: "Église", sortable: true, sortBy:(el)=>el.eglise.nom.toLowerCase(), row: (row, index)=><TableCell key={index} align="center" sx={{textTransform:'capitalize'}} >{row.eglise.nom}</TableCell>},
        {header: "Statut", sortable: true, sortBy:(el)=>getStatusColors(el)?.text?.toLowerCase(), row: (row, index)=><TableCell key={index} align="center" sx={{color: getStatusColors(row).color, }} >{getStatusColors(row).text}</TableCell>},
        {header: "Espèces", sortable: false, row: (row, index)=>{
            const especes = [...row.fedRepartition.especes, ...row.fedRepartition.retrait].filter(es=>es.montant>0&&es.count>0)
            const str = [...new Set(especes.map(es=>es.montant))].sort((a,b)=>a.montant<b.montant).reduce((tt,montant,index)=>{
                const count = especes.filter(es=>es.montant===montant).reduce((tt,es)=>tt+es.count,0)
                return tt+count+' x '+montant.toFixed(2)+'€, '
            },'').slice(0,-2)
            return<TableCell key={index} sx={{minWidth:'200px'}}>{str}</TableCell>
        }},
        {header: "Chèques", sortable: false, row: (row, index)=><TableCell key={index} align='right' sx={{minWidth:'280px', whiteSpace:'pre-line'}}>
            {row.fedRepartition?.cheques.length>0&&<div style={{fontWeight:'bold', textAlign:'center'}}>{row.fedRepartition?.cheques.length} chèques:{'\n'}</div>}
            {row.fedRepartition?.cheques.reduce((tt, cq, index)=>tt+cq.banque+' n°'+cq.num_cheque+' de '+cq.montant.toFixed(2)+(index===row.fedRepartition?.cheques.length-1?'€': '€\n'),'')}
        </TableCell>},
        {header: "Montant total", sortable: true, sortBy:(row)=>[...row.fedRepartition.especes, ...row.fedRepartition.retrait].reduce((tt,es)=>tt+es.montant*es.count,0), row:(row, index)=><TableCell key={index}>{([...row.fedRepartition.especes, ...row.fedRepartition.retrait].filter(es=>es.montant>0&&es.count>0).reduce((tt,es)=>tt+es.montant*es.count,0)+row.fedRepartition.cheques.reduce((tt,ch)=>tt+ch.montant,0)).toFixed(2)} €</TableCell>},
    ]

    function getStatusColors(vers){
        if (vers.is_error) {
            return {color: 'red', text: 'Erreur'}
        } else if (vers.is_fixed) {
            return {color: 'darkorange', text: 'Corrigé'}
        }
        return {color: 'black', text: 'En attente de validation'}
    }

    function manage_dialog(status, action) {
        setOpen(status)
        setAction(action)
        if (!status) {
            setSelect()
            setPdf()
        }
    }

    function create_bdr_versement(vers) {return new Promise((resolve, reject) => {
        fetch(API.concat(`/eglises/by/${JSON.stringify({type:'fédération'})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const pdfDocGenerator = pdfMake.createPdf(bord_versement(json[0], vers, vers.eglise));
                    pdfDocGenerator.getBlob((blob) => {
                        resolve(URL.createObjectURL(blob))
                    });
                } else resolve()
            }
        })
    })}

    function get_bdr_versement(vers) {
        setLoad(true)
        create_bdr_versement(vers).then((pdf_url) => {
            setPdf(pdf_url)
            manage_dialog(true, 'pdf')
            setLoad(false)
        })
    }

    function print_bdr(vers) {
        setLoad(true)
        create_bdr_versement(vers).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = function() {
                win.print();
                };
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoad(false)
        })
    }

    function get_Msearchable(vers) {
        return selectedMCol.reduce((all, current)=> all+montant_columns.find(col=> col.header===current)?.search(vers)+' ','')
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(vers) {
        return vers.eglise.nom
    }

    function handleCash(versId) {
        setLoad(true)
        manage_dialog(false, '')
        fetch(API.concat(`/validate/versements/${JSON.stringify(versId)}`), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        setVers(old=> old.filter(v=>!versId.includes(v._id)))
                    }setLoad(false)
                }
        })
    }

    function handleCancelWarning(versId) {
        setLoad(true)
        manage_dialog(false, '')
        fetch(API.concat(`/versement/${versId}/alert/cancel`), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const {versement, eglise} = await response.json()
                        versement.eglise = eglise
                        setVers(old=> old.map(v=>v._id===versId ? versement : v))
                    }setLoad(false)
                }
        })
    }

    useEffect(()=>{
        async function get_versements() {
            fetch(API.concat(`/versements/federal/by/${JSON.stringify({is_valid: false, is_cloture: false, fedVerseType:'siege'})}`), {method:'GET', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }}).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const {versements, eglises} = await response.json()
                        Promise.all(versements.map(ver=>{return new Promise((resolve, reject) => {
                            ver.eglise = eglises.find(el=>el.number===ver.eglise)
                            resolve(ver)
                        })})).then(result=> {
                            setVers(result)
                            setLoad(false)
                        })
                    } else setLoad(false)
                }
            })
        }
        get_versements()
    }, [updateConnect])

    return(
        <Box display='flex' flex={1} flexDirection='column'>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Encaissement des Versements</Typography>
            <Box sx={{display:'flex', flexDirection:'column', paddingX:'20px', marginTop:'30px'}}>
                <Box style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'10px'}}>
                    <Stack direction='row' spacing={1} alignItems='center'>
                        <TextField
                        label="Rechercher un montant"
                        size="small"
                        type="number"
                        disabled={!vers?.length>0}
                        sx={{width:'20%', minWidth:'200px', maxWidth:'350px'}}
                        value={montant}
                        onFocus={()=>{if(montant===0) setMontant('')}}
                        onChange={(event)=>{
                            if (event.target.value.split('.').length<2 || !(event.target.value.split('.')[1]?.length>2)) {
                                setMontant(event.target.value)  
                            } 
                        }}
                        />
                        <Typography variant="body1">dans</Typography>
                        <FormControl sx={{ m: 1, width:'20%', minWidth: '200px' }}>
                            <InputLabel>Colonnes</InputLabel>
                            <Select
                            size="small"
                            multiple
                            renderValue={(selected) => selected.join(', ')}
                            sx={{ width:'100%', maxWidth:'500px'}}
                            label="Colonnes"
                            value={selectedMCol}
                            onChange={(e)=>setSelectMCol(e.target.value.flat())}
                            >
                                {montant_columns.map((col, index) => (
                                    <MenuItem key={index} value={col.header}>
                                        <Typography>{col.header}</Typography> 
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                    <Button variant='contained' disabled={selectItems.length<1} sx={{marginBlock:'10px'}} onClick={()=>manage_dialog(true,'cash many')}>Encaisser</Button>
                </Box>
                
                <TextField
                label="Rechercher par église"
                size="small"
                disabled={!vers?.length>0}
                sx={{width:'60%', minWidth:'300px', marginInline:5, alignSelf:'center'}}
                value={search_input}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                        <Search />
                        </InputAdornment>
                    ),
                }}
                onChange={(event)=>setSearch(event.target.value)}
                />

                {vers && <SorTableCheckable data={vers.filter(ver=> normalize(get_searchable(ver)).includes(normalize(search_input))&&(montant?.length>0&&selectedMCol.toString()!==''&&selectedMCol.toString()!==' ' ? get_Msearchable(ver).includes(montant): true))} selectItems={selectItems} setItems={setItems} table={table.concat([editCol])} rowsPerPage={25} rowsPerPageOptions={[25, 50, 100, 300]}/>}
            </Box>

            <Dialog fullScreen={action==='edit'} open={open} onClose={()=>manage_dialog(false, '')} maxWidth={action?.includes('cash')||action==='cancelWarning'?'sm':'md'} fullWidth PaperProps={{sx : {overflow: action==='pdf'?'hidden':'auto'}}} >
                <IconButton sx={{ alignSelf:'end'}} onClick={()=>{manage_dialog(false, '')}}><Close/></IconButton>
                {action==='info' && selected && <VersHistory id={selected._id} vers={selected} vers_num={selected.bordereau_num??''}/>}
                {action==='pdf' && pdf && <embed src={pdf} fullWidth height='600px' style={{marginInline:'20px'}} type="application/pdf" />}
                {action==='warning' && selected && <VersWarning vers={selected} setVerses={edited=>setVers(old=>[...old.filter(v=>v._id!==edited._id), edited])} validate={verse=>handleCash([verse])} close={()=> manage_dialog(false, '')} />}
                {action==='cash' && selected && <Box display='flex' flex={1} flexDirection="column" paddingInline={3} paddingBottom={4}>
                    <Typography align='center' variant='h5' fontWeight='600' sx={{marginBottom:2}}>Encaisser le versement {selected.bordereau_num} de {([...selected.fedRepartition?.especes,...selected.fedRepartition?.retrait].filter(es=>es.montant>0&&es.count>0).reduce((tt,es)=>tt+es.montant*es.count,0)+selected.fedRepartition?.cheques.reduce((tt,ch)=>tt+ch.montant,0)).toFixed(2)}€ </Typography>
                    <Typography variant='subtitle1'>Espèces:</Typography>
                    {[...new Set(selectedEspeces.map(es=>es.montant))].sort((a,b)=>b-a).map(montant=>{
                        const count = selectedEspeces.filter(es=>es.montant===montant).reduce((tt,es)=>tt+es.count,0)
                        return<Typography key={montant}>- {count} {montant<5?'pièce':'billet'}{count>1&&'s'} de {montant.toFixed(2)}€</Typography>
                    })}
                    <Typography variant='subtitle1' marginTop={2}>Chèques:</Typography>
                    {selected.fedRepartition?.cheques.map(cheque=><Typography key={cheque.num_cheque}>- chèque {cheque.banque} n°{cheque.num_cheque} de {cheque.montant.toFixed(2)}€</Typography>)}
                    <Button variant='contained' onClick={()=>handleCash([selected._id])} sx={{marginTop:2}}>valider</Button>
                </Box>}
                {action==='cash many' && selectItems.length>0 && <Box display='flex' flex={1} flexDirection="column" paddingInline={3} paddingBottom={4}>
                    <Typography align='center' variant='h5' fontWeight='600' sx={{marginBottom:2}}>Encaisser {selectItems.length} versement(s)</Typography>
                    <Typography variant='subtitle1'>Espèces:</Typography>
                    {[...new Set(filteredVers.map(v=>[...v.fedRepartition?.especes, ...v.fedRepartition?.retrait].map(money=>money.montant)).flat())].filter(m=>m>0).sort((a,b)=>b-a).map(montant =>
                        <Typography key={montant}>- {filteredVers.reduce((tt,v)=>tt+[...v.fedRepartition?.especes, ...v.fedRepartition?.retrait].filter(es=>es.montant===montant).reduce((total,m)=>total+m.count,0),0)} {montant<5?'pièce(s)':'billet(s)'} de {montant?.toFixed(2)}€</Typography>
                    )}
                    <Typography variant='subtitle1' marginTop={2}>Chèques:</Typography>
                    {filteredVers.map(v=>v.fedRepartition?.cheques).flat().map(cheque=>
                        <Typography key={cheque.num_cheque}>- chèque {cheque.banque} n°{cheque.num_cheque} de {cheque.montant.toFixed(2)}€</Typography>
                    )}
                    <Button variant='contained' onClick={()=>handleCash(selectItems)} sx={{marginTop:2}}>valider</Button>
                </Box>}
                {action==='cancelWarning' && selected&&<Box display='flex' flex={1} flexDirection="column" paddingInline={3} paddingBottom={4}>
                    <Typography align='center' variant='h5' fontWeight='600' sx={{marginBottom:2}}>Annuler le signalement du versement {selected.bordereau_num}</Typography>
                    <Typography>Êtes-vous sûr de vouloir annuler le signalement de ce versement et les modifications enregistrée en dépot réel ?</Typography>
                    <Stack direction='row' spacing={2} alignItems='center' justifyContent='end' sx={{marginTop:2}}>
                        <Button variant='outlined' onClick={()=>manage_dialog(false, '')} sx={{marginTop:2}}>annuler</Button>
                        <Button variant='contained' onClick={()=>handleCancelWarning(selected._id)} sx={{marginTop:2}}>confirmer</Button>
                    </Stack>
                </Box>}
            </Dialog>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}